var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTableHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 10.75H14.3125C14.4156 10.75 14.5 10.6656 14.5 10.5625V9.4375C14.5 9.33438 14.4156 9.25 14.3125 9.25H5.6875C5.58437 9.25 5.5 9.33438 5.5 9.4375V10.5625C5.5 10.6656 5.58437 10.75 5.6875 10.75Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 0.625H1.375C0.960156 0.625 0.625 0.960156 0.625 1.375V18.625C0.625 19.0398 0.960156 19.375 1.375 19.375H18.625C19.0398 19.375 19.375 19.0398 19.375 18.625V1.375C19.375 0.960156 19.0398 0.625 18.625 0.625ZM17.6875 17.6875H2.3125V2.3125H17.6875V17.6875Z",
    fill: "#262626"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableHide);
export default __webpack_public_path__ + "static/media/table-hide.38cffa8925811619f52b55fc7edaceb4.svg";
export { ForwardRef as ReactComponent };